import React from "react";
import { PageWrapper } from "components/pages";
import { BookingDetails } from "features/BookingDetails";
import { useParams } from "react-router-dom";

const BookingDetailsPage = () => {
  const params = useParams();
  const bookingId = params.id;

  return (
    <PageWrapper>
      <BookingDetails bookingId={bookingId} />
    </PageWrapper>
  );
};

export default BookingDetailsPage;
